import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Firebase 프로젝트 설정에서 복사한 정보
const firebaseConfig = {
    apiKey: "AIzaSyCjoJURiDxnZr8z2xRgLBgbMurzRmoYEVc",
    authDomain: "bnf-login.firebaseapp.com",
    projectId: "bnf-login",
    storageBucket: "bnf-login.firebasestorage.app",
    messagingSenderId: "1015733525919",
    appId: "1:1015733525919:web:bd0360cbc58b1a4c5fb1aa",
    measurementId: "G-8XHNDWKSP6"
};

// Firebase 초기화
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
provider.setCustomParameters({
  prompt: "select_account"  // 계정 선택 창 항상 뜨게 강제
});

export { auth, provider };
